module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.carregandoDados) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pa-0": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "width": _vm.$vuetify.breakpoint.xsOnly ? '98%' : '40%'
    },
    model: {
      value: (_vm.mostraHelp),
      callback: function($$v) {
        _vm.mostraHelp = $$v
      },
      expression: "mostraHelp"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_c('span', {
    staticClass: "title-ementa"
  }, [_vm._v(_vm._s(_vm.titulo) + " "), (_vm.turno) ? _c('span', [_vm._v("(" + _vm._s(_vm.turno) + ")")]) : _vm._e()])]), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "text-align": "justify",
      "height": "300px"
    }
  }, [_c('span', {
    staticClass: "ementa"
  }, [_vm._v("    " + _vm._s(_vm.ementa))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostraHelp = false
      }
    }
  }, [_vm._v("\n            Ok, entendi!\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": _vm.temCPP(),
      "lg6": _vm.temCPP()
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4",
      "mx-0": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Qual curso deseja se matricular?")]), _vm._v(" "), (_vm.dependencias.contratos.length) ? [_c('v-radio-group', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.dadosMatricula.matricula.ref_curriculo),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "ref_curriculo", $$v)
      },
      expression: "dadosMatricula.matricula.ref_curriculo"
    }
  }, _vm._l((_vm.dependencias.contratos), function(contrato, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "color": "secondary",
        "value": contrato.ref_curriculo
      }
    }, [_c('div', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(contrato.descricao)), _c('v-chip', [_vm._v(_vm._s(contrato.cidade) + " - " + _vm._s(contrato.turno))])], 1)])
  }), 1)] : [_vm._v("\n                      Nenhum currículo disponível para matrícula.\n                    ")], _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "title mb-3"
  }, [_vm._v("Abaixo estão as disciplinas que você vai cursar neste semestre")]), _vm._v(" "), (_vm.contratoSelecionado) ? [(_vm.contratoSelecionado.modulo.disciplinas) ? [(_vm.contratoSelecionado.modulo.descricao) ? _c('h4', {
    staticClass: "subheading mb-3"
  }, [_vm._v(_vm._s(_vm.contratoSelecionado.modulo.descricao))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contratoSelecionado.modulo.disciplinas), function(disciplina) {
    return _c('div', {
      key: disciplina.id,
      staticClass: "lista-disciplinas",
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.help(disciplina.descricao, disciplina.ementa, disciplina.turno)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('span', {
            staticClass: "ma-2",
            attrs: {
              "icon": ""
            }
          }, [(disciplina.tipo_matriz === 'CPP' && _vm.contratoSelecionado.solicitarVagaCpp) ? [_c('v-icon', {
            attrs: {
              "color": "red accent-2"
            }
          }, [_vm._v("warning")])] : _vm._e(), _vm._v(" "), (disciplina.tipo_matriz !== 'CPP' || (disciplina.tipo_matriz === 'CPP' && !_vm.contratoSelecionado.solicitarVagaCpp)) ? [_c('v-icon', {
            attrs: {
              "color": "light-green accent-2"
            }
          }, [_vm._v("check_circle")])] : _vm._e()], 2)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Detalhes da Disciplina")])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_vm._v("\n                                      " + _vm._s(disciplina.descricao) + "\n                                      "), (disciplina.tipo_matriz === 'CPP' && _vm.contratoSelecionado.solicitarVagaCpp) ? [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "color": "red"
      }
    }, [_vm._v("\n                                          * Solicite sua vaga com o coordenador\n                                        ")])] : _vm._e()], 2), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "primary"
            }
          }, [_vm._v("info")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Detalhes da Disciplina")])])], 1)], 1)], 1)
  })] : [_vm._v("\n                              Curso com disciplinas ainda indisponíveis. Entre em contato com a Central de Atendimento para maiores informações.\n                            ")]] : [_vm._v("\n                          Nenhum contrato selecionado\n                        ")]], 2)], 2)], 1)], 1), _vm._v(" "), (_vm.temCPP()) ? _c('v-flex', {
    attrs: {
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-3 ma-0 pa-0"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-1"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Selecione a CPP que deseja cursar nesse módulo")]), _vm._v(" "), (_vm.contratoSelecionado && _vm.contratoSelecionado.cpps.length) ? [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "radio-container d-flex",
    model: {
      value: (_vm.dadosMatricula.matricula.ref_disciplina_cpp),
      callback: function($$v) {
        _vm.$set(_vm.dadosMatricula.matricula, "ref_disciplina_cpp", $$v)
      },
      expression: "dadosMatricula.matricula.ref_disciplina_cpp"
    }
  }, [_vm._l((_vm.contratoSelecionado.cpps), function(disciplina) {
    return [_c('v-list-tile', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-action', [_c('v-radio', {
      key: disciplina.id,
      attrs: {
        "color": "secondary",
        "value": disciplina.id
      }
    }, [_vm._v(" \n                              ")])], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          return _vm.help(disciplina.descricao, disciplina.ementa, disciplina.turno)
        }
      }
    }, [_c('v-list-tile-title', {
      staticClass: "list-conteudo"
    }, [_vm._v("\n                                " + _vm._s(disciplina.descricao) + "\n                              ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(disciplina.turno))]), _vm._v(" "), (disciplina.turma_virtual == 'EAD') ? _c('v-list-tile-sub-title', [_c('v-chip', {
      staticClass: "ml-0",
      attrs: {
        "color": "blue",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v("\n                                    EAD\n                                ")])], 1) : _vm._e(), _vm._v(" "), (disciplina.turma_virtual == 'Virtual') ? _c('v-list-tile-sub-title', [_c('v-chip', {
      staticClass: "ml-0",
      attrs: {
        "color": "orange",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v("\n                                    100% Virtual\n                                ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', {
      on: {
        "click": function($event) {
          return _vm.help(disciplina.descricao, disciplina.ementa, disciplina.turno)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.help(disciplina.descricao, disciplina.ementa, disciplina.turno)
        }
      }
    }, [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2)], 1)] : _vm._e()], 2)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-header"
  }, [_c('navigation-buttons', {
    attrs: {
      "show-previous": true,
      "show-next": true,
      "previous-click": _vm.voltar,
      "next-click": _vm.salvarDados,
      "disable-next": ((_vm.$v.dadosMatricula.$invalid && _vm.contratoSelecionado.cpps.length > 0) || _vm.contratoSelecionado.solicitarVagaCpp)
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5c4560a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/DadosMatricula.vue
// module id = 576
// module chunks = 2